import React, { FunctionComponent } from "react";
import { useWhiteLabelSetting } from "components/WhiteLabelProvider";
import { useLingui } from "@lingui/react";

export interface Props {}

export const CompanyBanner: FunctionComponent<Props> = () => {
  const bannerURL = useWhiteLabelSetting("bannerLink") as string;
  const company = useWhiteLabelSetting("name") as string;
  const {
    i18n: { locale },
  } = useLingui();
  const [bannerImage, setBannerImage] = React.useState();

  React.useEffect(() => {
    const fetchBannerImage = async () => {
      const image = await import(`assets/${company}/banner_${locale.toLowerCase()}.jpg`);
      setBannerImage(image.default);
    };
    fetchBannerImage();
  }, [company, locale]);

  if (bannerURL && bannerImage) {
    return (
      <a href={bannerURL} target="_blank" className="banner" rel="noopener noreferrer">
        <img src={bannerImage} alt="banner" width="117" height="560" />
      </a>
    );
  }
  return (
    <div className="nobanner">
      <p></p>
    </div>
  );
};

CompanyBanner.displayName = "CompanyBanner";
